import { configureStore } from '@reduxjs/toolkit';

import userReducer from './user';
import usersReducer from './users';
import marketReducer from './market';
import ordersReducer from './orders';
// import tradesReducer from './trades';
// import transfersReducer from './transfers';
import accountReducer from './account';
// import ibdaxWalletReducer from './ibdaxWallet';
import holdingsReducer from './holdings';
import propertyReducer from './property';
import dividendReducer from './dividend';
import feeGroupReducer from './feeGroups';
// import applicationUsersReducer from './applicationUsers';
import invitedInvestorsReducer from './invitedInvestors';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import murabahaReducer from './murabaha';
import marketTradeReducer from './marketTrade';
import propertyUnitsReducer from './propertyUnits';
// import marketManagementReducer from './marketManagement';
// import marketAnnouncementsReducer from './marketAnnouncements';
// import propertyAnnouncementsReducer from './propertyAnnouncements';

const store = configureStore({
  reducer: {
    user: userReducer,
    users: usersReducer,
    market: marketReducer,
    orders: ordersReducer,
    // trades: tradesReducer,
    // transfers: transfersReducer,
    account: accountReducer,
    // ibdaxWallet: ibdaxWalletReducer,
    holdings: holdingsReducer,
    property: propertyReducer,
    dividends: dividendReducer,
    feeGroups: feeGroupReducer,
    // applicationUsers: applicationUsersReducer,
    invitedInvestors: invitedInvestorsReducer,
    // marketManagement: marketManagementReducer,
    // marketAnnouncements: marketAnnouncementsReducer,c
    // propertyAnnouncements: propertyAnnouncementsReducer,

    murabaha: murabahaReducer,
    marketTrade: marketTradeReducer,
    propertyUnits: propertyUnitsReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});

export default store;

/** Helper function to get the store type */
export type RootState = ReturnType<typeof store.getState>;
export type StateDispatch = typeof store.dispatch;

/** Helper function to get the state dispatcher */
export const useStateDispatch = () => useDispatch<StateDispatch>();

/** Helper function to get the state selector */
export const useStateSelector: TypedUseSelectorHook<RootState> = useSelector;

/** Get State from `functions` when need to access store outside of the components */
export function getUseStateSelector<T>(by: (state: RootState) => T) {
  return by(store.getState());
}
